class TargetTracketActions {
  static TARGET_TRACKER_YTD_BRAND_REQUEST = "TARGET_TRACKER_YTD_BRAND_REQUEST";
  static TARGET_TRACKER_YTD_BRAND_SUCCESSFUL = "TARGET_TRACKER_YTD_BRAND_SUCCESSFUL";
  static TARGET_TRACKER_YTD_BRAND_FAILED = "TARGET_TRACKER_YTD_BRAND_FAILED";

  static targetTrackerYTDBrandRequest() {
    return {
      type: this.TARGET_TRACKER_YTD_BRAND_REQUEST
    };
  }
  static targetTrackerYTDBrandSuccessul(data) {
    return {
      type: this.TARGET_TRACKER_YTD_BRAND_SUCCESSFUL,
      data
    };
  }
  static targetTrackerYTDBrandFailed(error) {
    return {
      type: this.TARGET_TRACKER_YTD_BRAND_FAILED,
      error
    };
  }
  
  //********* YTD BRAND MTFTS *********
  static TARGET_TRACKER_YTD_BRAND_MTFTS_REQUEST = "TARGET_TRACKER_YTD_BRAND_MTFTS_REQUEST";
  static TARGET_TRACKER_YTD_BRAND_MTFTS_SUCCESSFUL = "TARGET_TRACKER_YTD_BRAND_MTFTS_SUCCESSFUL";
  static TARGET_TRACKER_YTD_BRAND_MTFTS_FAILED = "TARGET_TRACKER_YTD_BRAND_MTFTS_FAILED";

  static targetTrackerYTDBrandMTFTSRequest() {
    return {
      type: this.TARGET_TRACKER_YTD_BRAND_MTFTS_REQUEST
    };
  }
  static targetTrackerYTDBrandMTFTSSuccessul(data) {
    return {
      type: this.TARGET_TRACKER_YTD_BRAND_MTFTS_SUCCESSFUL,
      data
    };
  }
  static targetTrackerYTDBrandMTFTSFailed(error) {
    return {
      type: this.TARGET_TRACKER_YTD_BRAND_MTFTS_FAILED,
      error
    };
  }
  
  //********* YTD BRAND ANP *********
  static TARGET_TRACKER_YTD_BRAND_ANP_REQUEST = "TARGET_TRACKER_YTD_BRAND_ANP_REQUEST";
  static TARGET_TRACKER_YTD_BRAND_ANP_SUCCESSFUL = "TARGET_TRACKER_YTD_BRAND_ANP_SUCCESSFUL";
  static TARGET_TRACKER_YTD_BRAND_ANP_FAILED = "TARGET_TRACKER_YTD_BRAND_ANP_FAILED";

  static targetTrackerYTDBrandANPRequest() {
    return {
      type: this.TARGET_TRACKER_YTD_BRAND_ANP_REQUEST
    };
  }
  static targetTrackerYTDBrandANPSuccessul(data) {
    return {
      type: this.TARGET_TRACKER_YTD_BRAND_ANP_SUCCESSFUL,
      data
    };
  }
  static targetTrackerYTDBrandANPFailed(error) {
    return {
      type: this.TARGET_TRACKER_YTD_BRAND_ANP_FAILED,
      error
    };
  }

  //********* TOTAL SPENT *********
  static TARGET_TRACKER_TOTAL_SPENT_REQUEST = "TARGET_TRACKER_TOTAL_SPENT_REQUEST";
  static TARGET_TRACKER_TOTAL_SPENT_SUCCESSFUL = "TARGET_TRACKER_TOTAL_SPENT_SUCCESSFUL";
  static TARGET_TRACKER_TOTAL_SPENT_FAILED = "TARGET_TRACKER_TOTAL_SPENT_FAILED";

  static targetTrackerTotalSpentRequest() {
    return {
      type: this.TARGET_TRACKER_TOTAL_SPENT_REQUEST
    };
  }
  static targetTrackerTotalSpentSuccessul(data) {
    return {
      type: this.TARGET_TRACKER_TOTAL_SPENT_SUCCESSFUL,
      data
    };
  }
  static targetTrackerTotalSpentFailed(error) {
    return {
      type: this.TARGET_TRACKER_TOTAL_SPENT_FAILED,
      error
    };
  }

  //********* DOWNLOAD TT XLX *********
  static DOWNLOAD_TT_XLX_REQUEST = "DOWNLOAD_TT_XLX_REQUEST";
  static DOWNLOAD_TT_XLX_SUCCESSFUL = "DOWNLOAD_TT_XLX_SUCCESSFUL";
  static DOWNLOAD_TT_XLX_FAILED = "DOWNLOAD_TT_XLX_FAILED";

  static downloadTTXlxRequest() {
    return {
      type: this.DOWNLOAD_TT_XLX_REQUEST
    };
  }
  static downloadTTXlxSuccessul(data) {
    return {
      type: this.DOWNLOAD_TT_XLX_SUCCESSFUL,
      data
    };
  }
  static downloadTTXlxFailed(error) {
    return {
      type: this.DOWNLOAD_TT_XLX_FAILED,
      error
    };
  }

  //********* DTTS BRAND LEVEL *********
  static DTTS_BRAND_LEVEL_REQUEST = "DTTS_BRAND_LEVEL_REQUEST";
  static DTTS_BRAND_LEVEL_SUCCESSFUL = "DTTS_BRAND_LEVEL_SUCCESSFUL";
  static DTTS_BRAND_LEVEL_FAILED = "DTTS_BRAND_LEVEL_FAILED";

  static dttsBrandLevelRequest() {
    return {
      type: this.DTTS_BRAND_LEVEL_REQUEST
    };
  }
  static dttsBrandLevelSuccessul(data) {
    return {
      type: this.DTTS_BRAND_LEVEL_SUCCESSFUL,
      data
    };
  }
  static dttsBrandLevelFailed(error) {
    return {
      type: this.DTTS_BRAND_LEVEL_FAILED,
      error
    };
  }
}

export default TargetTracketActions;
